import {
  Autocomplete,
  type AutocompleteProps,
  ClickAwayListener,
  TextField
} from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { BrowserView, isMobile, MobileView } from 'react-device-detect'

export type MolsonAutocompleteProps<T> = AutocompleteProps<
  T,
  boolean | undefined,
  boolean | undefined,
  boolean | undefined
> & {
  dataTestId?: string
}

export const MolsonAutocomplete = <T,>({
  dataTestId,
  ...props
}: MolsonAutocompleteProps<T>) => {
  const [open, setOpen] = useState(false)
  const [showKeyboard, setShowKeyboard] = useState(false)
  const inputRef = useRef(null)

  const handleInputClick = () => {
    if (open) {
      if (!showKeyboard) {
        setShowKeyboard(true)
      } else {
        setOpen(false)
      }
    } else {
      setOpen(true)
    }
  }

  const handleClickAway = () => {
    setOpen(false)
    setShowKeyboard(false)
    if (inputRef.current) {
      //@ts-ignore
      inputRef.current.blur()
    }
  }

  useEffect(() => {
    if (showKeyboard && inputRef.current) {
      //@ts-ignore
      inputRef.current.focus()
    }
  }, [showKeyboard])

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div style={{ width: '100%' }}>
        <Autocomplete
          {...props}
          onChange={(e, val, reason) => {
            if (props.onChange) {
              props.onChange(e, val, reason)
            }

            if (isMobile) {
              handleClickAway()
            }
          }}
          open={isMobile ? open : undefined}
          renderInput={params => {
            //@ts-ignore
            const mobileTextFieldParams = props.renderInput(params)?.props
            return (
              <>
                <BrowserView>{props.renderInput(params)}</BrowserView>
                <MobileView>
                  <TextField
                    {...params}
                    {...mobileTextFieldParams}
                    focused={open}
                    inputRef={inputRef}
                    onClick={handleInputClick}
                    InputProps={{
                      ...params.InputProps,
                      onFocus: e => {
                        if (isMobile && !showKeyboard) {
                          e.target.blur()
                        }
                      }
                    }}
                  />
                </MobileView>
              </>
            )
          }}
        />
      </div>
    </ClickAwayListener>
  )
}
